import React from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

const languages = [
  { code: 'en', flag: '\u{1F1EC}\u{1F1E7}' },
  { code: 'it', flag: '\u{1F1EE}\u{1F1F9}' },
  { code: 'fr', flag: '\u{1F1EB}\u{1F1F7}' },
  { code: 'es', flag: '\u{1F1EA}\u{1F1F8}' },
  { code: 'de', flag: '\u{1F1E9}\u{1F1EA}' },
];

export const LanguageSelector: React.FC = () => {
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language;

  const handleLanguageChange = (langCode: string) => {
    i18n.changeLanguage(langCode);
  };

  const currentLanguage = languages.find((l) => l.code === currentLang) || languages[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="rounded-full w-9 h-9 text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors"
          aria-label={t('language.select', 'Lingua')}
        >
          <span className="text-base leading-none">{currentLanguage.flag}</span>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="end"
        className="w-44 rounded-xl border-border bg-white shadow-lg shadow-primary/5 p-1"
      >
        {languages.map((lang) => {
          const isActive = currentLang === lang.code;
          return (
            <DropdownMenuItem
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`flex items-center justify-between cursor-pointer rounded-lg px-3 py-2.5 transition-colors ${
                isActive ? 'bg-secondary/60 text-foreground' : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              <div className="flex items-center gap-3">
                <span className="text-base leading-none">{lang.flag}</span>
                <span className="font-medium text-sm">{t(`language.${lang.code}`)}</span>
              </div>
              {isActive && (
                <Check className="w-4 h-4 text-primary" strokeWidth={3} />
              )}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
